module.exports = __webpack_public_path__ + "static/media/Statua_030.2fd44605.jpg";